import { render, staticRenderFns } from "./queryYfd.vue?vue&type=template&id=5e80f604&scoped=true&"
import script from "./queryYfd.vue?vue&type=script&lang=js&"
export * from "./queryYfd.vue?vue&type=script&lang=js&"
import style0 from "./queryYfd.vue?vue&type=style&index=0&id=5e80f604&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80f604",
  null
  
)

export default component.exports